import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { InterviewSource } from '@/types/interview-source';

import { useInterviewContext } from '../contexts/interview.context';
import { useLanguageContext } from '../contexts/language.context';

/**
 * Hook to reset navigation on cancel/logout. Redirects to dashboard when interview
 * was started from dashboard (source=Dashboard), otherwise to app home.
 */
export function useResetToHome() {
  const navigate = useNavigate();
  const { clearFastpassLanguage } = useLanguageContext();
  const { interviewSource } = useInterviewContext();

  const resetToHome = useCallback(() => {
    clearFastpassLanguage();

    if (interviewSource === InterviewSource.Dashboard) {
      navigate('/dashboard', { replace: true });
      return;
    }

    navigate('/', { replace: true });
  }, [navigate, clearFastpassLanguage, interviewSource]);

  return { resetToHome };
}
